import { useQuery } from '@apollo/client';
import {
    CURRENT_USER_OPERABLE_WAREHOUSES,
    CurrentUserOperableWarehousesResponse,
} from '../graphql/queries/currentUserOperableWarehouses';
import { SiteType } from '../graphql/types/SiteType';

type Options = {
    skip?: boolean;
    fetchPolicy?: 'cache-first' | 'cache-only' | 'network-only' | 'no-cache' | 'standby';
};

/**
 * 获取当前登录用户有权限操作的仓库列表（全部类型）
 * 纯数据接口，不包含业务逻辑，需要手动控制查询
 */
export const useCurrentUserOperableHubAndWarehouses = (options?: Options) => {
    const { skip = false, fetchPolicy = 'cache-first' } = options || {};

    const { data, loading, error, refetch } = useQuery<CurrentUserOperableWarehousesResponse>(
        CURRENT_USER_OPERABLE_WAREHOUSES,
        {
            skip,
            fetchPolicy,
            errorPolicy: 'all',
            notifyOnNetworkStatusChange: false,
        }
    );

    return {
        warehouses: data?.warehouses || [],
        loading,
        error,
        refetch,
    };
};

/**
 * 获取当前登录用户有权限操作的 Warehouse 列表（siteType = WAREHOUSE）
 */
export const useCurrentUserOperableWarehouses = (options?: Options) => {
    const { warehouses, loading, error, refetch } = useCurrentUserOperableHubAndWarehouses(options);
    return {
        warehouses: warehouses.filter((w) => w.siteType === SiteType.WAREHOUSE),
        loading,
        error,
        refetch,
    };
};

/**
 * 获取当前登录用户有权限操作的 Hub 列表（siteType = HUB）
 */
export const useCurrentUserOperableHubs = (options?: Options) => {
    const { warehouses, loading, error, refetch } = useCurrentUserOperableHubAndWarehouses(options);
    return {
        warehouses: warehouses.filter((w) => w.siteType === SiteType.HUB),
        loading,
        error,
        refetch,
    };
};
